import { defineMessages, type MessageValue } from 'react-intl';

export const lineItemNameMessages = defineMessages<{
  readonly customProductName: { readonly product_name: MessageValue };
}>({
  customProductName: {
    defaultMessage: 'Custom {product_name}',
    description: 'Lite item | Name | Custom product name',
  },
});
